// extracted by mini-css-extract-plugin
export default {"grid_cols_custom":"AlbumSeeAll_grid_cols_custom__MR68l"};